export default __webpack_public_path__ + "static/media/jira.c25811e8.svg";